import { White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  width: '100vw',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
});

export const loadingAnimation = css({
  width: 532,
  height: 298
});

export const title = css({
  fontFamily: 'Pretendard',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: 32,
  lineHeight: '130%',
  textAlign: 'center',
  color: White.White10,
  opacity: 0.5,
  flex: 'none',
  order: 4,
  flexGrow: 0
});
